import React, {useState, useMemo, useEffect} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import profile_img from '../assets/images/profile_img.png';
import penciledit from '../assets/images/profile-edit.svg';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { apiUrl } from "../config/Config";
import { useLocation } from 'react-router-dom';
import userplaceholderimg from '../assets/images/userplaceholder.png';

const UpdateInternalUser = () => {
    const [orderstatus, setorderstatus] = useState('editprofile');
    const [firstname, setfirstname] = useState("");
    const [lastname, setlastname] = useState("");
    const [email, setemail] = useState("");
    const [mobilenumber, setmobilenumber] = useState("");
    const [designation, setdesignation] = useState("");
    const [type, settype] = useState("");
    const [joiningdate, setjoiningdate] = useState("");
    const [username, setusername] = useState("");
    const [password, setpassword] = useState("");
    const [repassword, setrepassword] = useState("");
    const [image, setimage] = useState("");
    const [showloding, setshowloding] = useState(false);
    const [error, setError] = useState('');

    const location = useLocation(); 
    const { state } = location;

    const dispatch = useDispatch();

    console.log('state >>', state);

    const handletoggleorders = (status) => {
        setorderstatus(status);
    }

    let navigate = useNavigate();
    const userdata = useSelector((store) => store.userReducer.userdata);

    const validatePassword = (text) => {
      // Regular expression to match the password criteria
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
      
      // Check if the password matches the regex
      if (regex.test(text)) {
        setError('');
        return true;
      } else {
        setError('Password must be at least 8 characters long and include a combination of uppercase, lowercase, numbers, and special characters.');
        return false;
      }
    };

    const handlesubmituser = async() => {
        // navigate('/users');

        if(password) {
          if(password == repassword) {
            if(validatePassword(password)) {

            } else {
              return;
            }
          } else {
            alert('Passwrod and re-type password does not match!!');
            return;
          }
        } else {
          
        }
        setshowloding(true);
            var data = {
              'userid': state?.userid,
              'firstname': firstname,
              'lastname': lastname,
              'email': email,
              'mobile': mobilenumber,
              'designation': designation,
              'type': type,
              'joiningdate': joiningdate,
              'username': username,
              'password': password,
              'image': null,
              'status': 'true',
            }
            const headers = {
              headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer " + userdata?.token,
              }
          }
          let resp = await axios.post(apiUrl + 'updateuseraccount', data, headers).then((res) => {
            if(res.data.status == 'success') {
              navigate('/users');
            } else {
              if(res.data.message == 'invalid user') {
                dispatch({ type: "userdata", payload: {} })
                navigate('/login');
              } else {
                alert(res.data.message);
              }
            }
        } ).catch((err) => {
            alert(err.message)
        })
        setshowloding(false);
        
        
        console.log('data >>', data)
    }

    const fetchdata = async(id) => {
      setshowloding(true);
      var data = {
        userid: id
      }
      const headers = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: "Bearer " + userdata?.token,
        }
      }
      let resp = await axios.post(apiUrl + 'getinternaluserdetails', data, headers).then((res) => {
        if(res.data.status == 'success') {
          if(Object.keys(res?.data?.data)) {
            var userdata = res?.data?.data;
            setfirstname(userdata?.firstname);
            setlastname(userdata?.lastname);
            setemail(userdata?.email);
            setmobilenumber(userdata?.mobile);
            setdesignation(userdata?.designation);
            settype(userdata?.type);
            setjoiningdate(userdata?.joiningdate);
            setusername(userdata?.username);
          } else {
            setfirstname("");
            setlastname("");
            setemail("");
            setmobilenumber("");
            setdesignation("");
            settype("");
            setjoiningdate("");
            setusername("");
          }
          
          // navigate('/users');
        } else {
          if(res.data.message == 'invalid user') {
            dispatch({ type: "userdata", payload: {} })
            navigate('/login');
          } else {
            alert(res.data.message);
          }
        }
    } ).catch((err) => {
        alert(err.message)
    })
    setshowloding(false);
    }

    useEffect(() => {
            if (userdata && Object.keys(userdata).length > 0) {
              if(state?.userid) {
                fetchdata(state?.userid);
              } else {
                navigate('/add-internal-user');
              }
              if(userdata?.type == "superadmin") {

              } else {
                navigate("/dashboard");
              }
                
            } else {
              navigate("/login");
            }
          }, []);

    return (
      <div className="">
        <div className="dashboardbox" style={{ width: "100%" }}>
          <div className="productstogglebar mt-2 profiletogglebar">
            <div className="orderstatustogglediv">
              <div
                className={
                  orderstatus == "editprofile"
                    ? "orderstatusdiv active"
                    : "orderstatusdiv"
                }
                onClick={() => {
                  handletoggleorders("editprofile");
                }}
              >
                <p>Update Internal User</p>
              </div>
              {/* <div
                className={
                  orderstatus == "security"
                    ? "orderstatusdiv active"
                    : "orderstatusdiv"
                }
                onClick={() => {
                  handletoggleorders("security");
                }}
              >
                <p>Security</p>
              </div> */}
            </div>
          </div>
          <div className="mt-5">
            <div className="row">
              <div className="col-md-3">
                <div className="profile-img-div">
                <img src={userplaceholderimg} className="profile_img" />
                  <div className="profile_edit-div">
                    <img src={penciledit} className="profile_edit" />
                  </div>
                </div>
              </div>
                <div className="col-md-9">
                <div className="row">
                  <div className="col-md-6 addproduct_reduce_width">
                    <div className="">
                      <label className="addproduct-label">First Name</label>
                      <input
                      value={firstname}
                      onChange={(t) => {setfirstname(t.target.value)}}
                        className="form-control addproductinput"
                        placeholder="Enter Firstname"
                      />
                    </div>
                    <div className="mt-3">
                      <label className="addproduct-label">Email</label>
                      <input
                      value={email}
                      onChange={(t) => {setemail(t.target.value)}}
                        className="form-control addproductinput"
                        placeholder="Enter Email"
                      />
                    </div>
                    {/* <div className="mt-3">
                      <label className="addproduct-label">Designation</label>
                      <input
                      value={designation}
                      onChange={(t) => {setdesignation(t.target.value)}}
                        className="form-control addproductinput"
                        placeholder="Enter Designation"
                      />
                    </div> */}
                    <div className="mt-3">
                      <label className="addproduct-label">Joining Date</label>
                      <input
                      type="date"
                      value={joiningdate}
                      onChange={(t) => {setjoiningdate(t.target.value)}}
                        className="form-control addproductinput"
                        placeholder="Date of Birth"
                      />
                    </div>
                    <div className="mt-3">
                      <label className="addproduct-label">Password</label>
                      <input
                      type="password"
                      value={password}
                      onChange={(t) => {setpassword(t.target.value)}}
                        className="form-control addproductinput"
                        placeholder="Enter Password"
                      />
                      {error && <p className="wrongpasswordformat">{error}</p>}
                    </div>
                  </div>
                  <div className="col-md-6 addproduct_reduce_width">
                    <div className="">
                      <label className="addproduct-label">Last Name</label>
                      <input
                      value={lastname}
                      onChange={(t) => {setlastname(t.target.value)}}
                        className="form-control addproductinput"
                        placeholder="Enter Lastname"
                      />
                    </div>
                    <div className="mt-3">
                      <label className="addproduct-label">Mobile Number</label>
                      <input
                      value={mobilenumber}
                      onChange={(t) => {setmobilenumber(t.target.value)}}
                      type="number"
                        className="form-control addproductinput"
                        placeholder="Enter Mobile Number"
                      />
                    </div>
                    <div className="mt-3">
                <label className="addproduct-label">Role</label>
                <select
                  className="form-control addproductinput"
                  value={type}
                  onChange={(t) => {settype(t.target.value)}}
                //   value={type}
                //   onChange={(t) => {
                //     settype(t.target.value);
                //   }}
                >
                  <option value={""} selected disabled>
                    Select Role
                  </option>
                  <option value={"agent"}>Risk Reviewer</option>
                  <option value={"admin"}>Manager</option>
                </select>
              </div>
                    {/* <div className="mt-3">
                      <label className="addproduct-label">User Name</label>
                      <input
                      value={username}
                      onChange={(t) => {setusername(t.target.value)}}
                      type="text"
                        className="form-control addproductinput"
                        placeholder="Enter Username"
                      />
                    </div> */}
                    <div className="mt-3">
                      <label className="addproduct-label">Re-type Password</label>
                      <input
                      value={repassword}
                      onChange={(t) => {setrepassword(t.target.value)}}
                      type="password"
                        className="form-control addproductinput"
                        placeholder="Enter Re-type Password"
                      />
                      {error && <p className="wrongpasswordformat">{error}</p>}
                    </div>
                    <div className="inventory-save-btn  profile-submitbtn" onClick={() => {handlesubmituser()}}>
                        <p>Update</p>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    );
}

export default UpdateInternalUser;